export default {
  default: 'grey-yellow',
  greyYellow: 'grey-yellow',
  blueYellow: 'blue-yellow',
  iprofile: 'iprofile',
};
